var map = {
	"./stock-1.png": 649,
	"./stock-11.png": 697,
	"./stock-2.png": 74,
	"./stock-22.png": 760,
	"./stock-3.png": 405,
	"./stock-33.png": 886,
	"./stock-4.png": 912,
	"./stock-44.png": 632
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 63;